export default __webpack_public_path__ + "static/media/fence.c301eee5.webp";